<template>
  <b-col md="4">
    <b-card class="mb-2">
      <b-tabs>
        <b-tab
          id="tab-right-1"
          title="ดำเนินการ"
        >
          <b-row>
            <b-col
              cols="12"
              class="ml-0"
            >
              <b-row>
                <b-col
                  v-for="(box, index) in optionSendType"
                  :key="index"
                  cols="12"
                  class="mt-1"
                >
                  <b-form-radio
                    :key="index"
                    :vaue="box.value"
                    name="sendType"
                  >
                    {{ box.text }}
                  </b-form-radio>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="12 mt-2">
              <b-form-group
                label="ความเห็นเจ้าหน้าที่"
                label-for="offficerComment"
              >
                <b-form-textarea
                  id="offficerComment"
                  placeholder="ความเห็นเจ้าหน้าที่"
                  rows="6"
                />
              </b-form-group>
              <b-form-file
                placeholder="Choose a file or drop it here..."
                drop-placeholder="Drop file here..."
              />
            </b-col>
            <b-col
              cols="12"
              class="d-flex justify-content-between mt-2"
            >
              <b-button variant="secondary">
                ยกเลิก
              </b-button>
              <b-button
                variant="primary"
                @click="getSuccess()"
              >
                ดำเนินการ
              </b-button>
            </b-col>

          </b-row>
        </b-tab>
        <b-tab
          id="tab-right-2"
          title="ประวัติ"
        />
      </b-tabs>
    </b-card>
  </b-col>

</template>

<script>

import {
  BRow, BCol, BFormTextarea, BFormGroup, BFormInput, BTab, BTabs, BCard, BFormRadioGroup, BFormSelect, BFormFile, BButton, BFormRadio,
} from 'bootstrap-vue'

export default {
  components: {
    BRow,
    BCol,
    BFormTextarea,
    BFormGroup,
    BFormInput,
    BTab,
    BTabs,
    BCard,
    BFormRadioGroup,
    BFormSelect,
    BFormFile,
    BButton,
    BFormRadio,
  },
  data() {
    return {
      optionSendType: [
        { text: 'อนุมัติ', value: 1 },
        { text: 'ส่งกลับ', value: 2 },
      ],
    }
  },
  methods: {
    getSuccess() {
      const routeData = this.$router.resolve({ name: 'ApproveConfirm' })
      window.open(routeData.href, '_self')
    },
  },
}
</script>

<style>

</style>
